import {StemDate} from "../../stem-core/src/time/Date";
import {apiConnection} from "../connection/BlinkApiConnection";
import {MoneyObject} from "./misc/Money";
import {PaymentStatusDependentStore} from "./misc/StoreUtils";
import {PaymentMethodStore} from "./PaymentMethodStore";

const TOP_UP_PAYMENT_STATUS = {
    NOT_PROCESSED: {code: "not_processed", name: "not processed"},
    FAILED: {code: "failed", name: "failed"},
    SUCCEEDED: {code: "succeeded", name: "succeeded"},
    REVERTED: {code: "reverted", name: "reverted"},
};

export class TopUpPayment extends MoneyObject {
    getDate() {
        return new StemDate(this.createdAt);
    }

    getPaymentMethod() {
        return PaymentMethodStore.get(this.paymentMethodId);
    }

    canBeReverted() {
        return this.status === TOP_UP_PAYMENT_STATUS.SUCCEEDED.code;
    }
}


class TopUpPaymentStoreClass extends PaymentStatusDependentStore("TopUpPayment", TopUpPayment) {
    Source = {
        PAYMENT_METHOD: "payment_method",
        CREDIT: "blink_credit",
    };
    Status = {
        FAILED: "failed",
        SUCCEEDED: "succeeded",
        REVERTED: "reverted",
    };

    getTransactionFromTopUpResponse(response) {
        return this.loadObjectFromResponse(response);
    }

    getSucceeded() {
        return this.all().filter(payment => payment.status === this.Status.SUCCEEDED);
    }
}

export const TopUpPaymentStore = new TopUpPaymentStoreClass();

export async function apiTopUp(amount, paymentMethod, currency) {
    const response = await apiConnection.post("/top_up_payments/top_up/", {
        amount,
        paymentMethodId: paymentMethod.id,
        currencyId: currency.id
    });
    return TopUpPaymentStore.loadObjectFromResponse(response);
}
